<style lang="scss" scoped>
.guest-page {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
}
.banner {
    width: 100%;
    height: 150px;
    background-size: cover;
    background-position: center -215px;
    @media (min-width: 1024px) {
        background-position: center;
        height: 100%;
    }
}
.cushion {
    position: absolute;
    width: 65px;
    top: 120px;
    left: 0;
    right: 0;
    margin: 0 auto 0 auto;
    @media (min-width: 1024px) {
        width: 192px;
        height: 182px;
        margin: 0 0 0 calc(-192px / 2);
        top: 65px;
    }
}
</style>

<template>
    <div class="guest-page container-fluid ">
        <div class="row h-100">
            <div class="col-12 col-lg-6 order-2 order-lg-1 h-lg-100 oy-lg-auto">
                <div class="container p-32 p-xl-100 h-100">
                    <router-view class="h-100" :key="$route.path" />
                </div>
            </div>
            <div class="col-12 col-lg-6 px-0 order-1 order-lg-2 h-lg-100">
                <img class="cushion d-lg-none d-xl-block" src="/images/cushion.png" alt="Start to sleep">
                <div class="banner" :style="{ 'background-image' : 'url(/images/login-banner-image.png)'}"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
};
</script>
